"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.DefaultConfigurationValues = {
    portalClass: "",
    language: "en",
    themeName: "hg"
};
exports.OuiConfigurationContext = React.createContext(exports.DefaultConfigurationValues);
var OuiAriaLiveContextDefault = {
    setPoliteMessage: undefined,
    setAssertiveMessage: undefined
};
exports.OuiAriaLiveContext = React.createContext(OuiAriaLiveContextDefault);
exports.OuiConfigurationContextProvider = exports.OuiConfigurationContext.Provider;
exports.OuiConfigurationContextConsumer = exports.OuiConfigurationContext.Consumer;
//# sourceMappingURL=types.js.map